import { HttpClient } from '../HttpClient';

/**
 * Get Widget
 * @returns {Promise<any>}
 */

export const GetWidget = async () => {
  try {
    const response = await HttpClient.get('/api/v1/widget');
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};
